// Mock data for Devsurf AI Services Website

export const services = [
  {
    id: 1,
    title: "AI Agent Development",
    description: "Custom AI agents for any domain including finance, healthcare, e-commerce, customer support, education, and real estate.",
    icon: "Bot",
    details: "Build intelligent agents that automate complex workflows and decision-making processes tailored to your industry needs."
  },
  {
    id: 2,
    title: "AI-Powered Chatbots & Virtual Assistants",
    description: "Intelligent conversational AI that enhances customer experience and streamlines support operations.",
    icon: "MessageSquare",
    details: "Deploy sophisticated chatbots that understand context, handle complex queries, and provide personalized assistance 24/7."
  },
  {
    id: 3,
    title: "Computer Vision Solutions",
    description: "Advanced image recognition, object detection, and face recognition systems for diverse applications.",
    icon: "Eye",
    details: "Leverage cutting-edge computer vision technology for automated visual analysis, quality control, and security applications."
  },
  {
    id: 4,
    title: "NLP Solutions",
    description: "Document summarization, sentiment analysis, and language translation powered by advanced natural language processing.",
    icon: "FileText",
    details: "Transform unstructured text data into actionable insights with our comprehensive NLP solutions."
  },
  {
    id: 5,
    title: "Custom AI Model Development",
    description: "Tailored AI models and seamless integration solutions designed specifically for your business requirements.",
    icon: "Settings",
    details: "From concept to deployment, we develop and integrate custom AI models that solve your unique challenges."
  },
  {
    id: 6,
    title: "AI-Powered Digital Twins for Predictive Maintenance",
    description: "Create dynamic virtual replicas of physical assets to predict failures and optimize maintenance in real-time.",
    icon: "FileText",
    details: "We build and manage high-fidelity digital twins for your machinery, reducing downtime by up to 30% and extending asset life."
  },
  {
    id: 7,
    title: "Multimodal AI Development Services",
    description: "Build holistic AI systems that understand and integrate data from multiple sources like text, audio, video, and images.",
    icon: "FileText",
    details: "We create context-aware AI that processes diverse data streams simultaneously for more accurate predictions and intelligent automation."
  },
  {
    id: 8,
    title: "Contract Intelligence & Analysis",
    description: "Transform legal documents into strategic assets with AI-powered contract analysis, risk stratification, and predictive insights.",
    icon: "FileText",
    details: "Our service automates contract review, benchmarks terms against market standards, and predicts negotiation outcomes to give you a competitive edge."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Alex Thompson",
    title: "Founder, Synthia",
    quote: "Devsurf developed our voice AI agent that revolutionized how we handle customer interactions. Their expertise in conversational AI helped us create a product that truly understands and responds naturally to users.",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    title: "Operations Director, Troker",
    quote: "The logistics AI solution Devsurf built for us optimized our entire supply chain. Route optimization and demand forecasting improved by 85%, saving us significant operational costs.",
    rating: 5
  },
  {
    id: 3,
    name: "Marcus Johnson",
    title: "Technology Head, A Leading Legal Tech Firm (US)",
    quote: "Devsurf's AI-powered document analysis and contract review system transformed our legal workflows. Case processing time reduced by 70% while maintaining accuracy and compliance standards.",
    rating: 5
  },
  {
    id: 4,
    name: "Sarah Chen",
    title: "CEO, DigiProp",
    quote: "Their multi-agent AI system transformed our property management workflow. The AI agents handle client inquiries 24/7 while our brokers sleep, providing instant responses and dramatically improving both our efficiency and client satisfaction.",
    rating: 5
  },
  {
    id: 5,
    name: "David Rodriguez",
    title: "CTO, TechFlow Solutions",
    quote: "Devsurf implemented n8n workflow automation that streamlined our entire development process. Their solution eliminated manual tasks and improved our team's productivity by 60% across all departments.",
    rating: 5
  },
  {
    id: 6,
    name: "Lisa Patel",
    title: "Product Manager, InnovaSoft",
    quote: "Devsurf's AI consultation and product review were invaluable. Their detailed analysis and recommendations helped us optimize our AI product, resulting in 40% better performance and enhanced user experience.",
    rating: 5
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Alex Thompson",
    title: "CEO & Founder",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face",
    bio: "AI visionary with 10+ years in machine learning and business strategy."
  },
  {
    id: 2,
    name: "Dr. Lisa Wang",
    title: "Chief AI Officer",
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=400&fit=crop&crop=face",
    bio: "PhD in Computer Science, expert in deep learning and neural networks."
  },
  {
    id: 3,
    name: "Marcus Johnson",
    title: "Lead AI Engineer",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face",
    bio: "Specializes in computer vision and NLP with 8+ years of industry experience."
  },
  {
    id: 4,
    name: "Priya Patel",
    title: "AI Solutions Architect",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&crop=face",
    bio: "Expert in AI integration and custom model development for enterprise clients."
  }
];

export const aiProcessSteps = [
  {
    id: 1,
    title: "AI Strategy & Discovery",
    description: "We identify AI opportunities, assess your data landscape, and develop a strategic roadmap tailored to your business objectives."
  },
  {
    id: 2,
    title: "Data Engineering & Preparation",
    description: "We build robust data pipelines, clean and structure your datasets, and establish the foundation for successful AI implementation."
  },
  {
    id: 3,
    title: "AI Model Development & Validation",
    description: "Our team develops, trains, and rigorously validates custom AI models using cutting-edge algorithms, ensuring accuracy and reliability through comprehensive testing."
  },
  {
    id: 4,
    title: "Deployment & Optimization",
    description: "We deploy your AI solution with seamless integration, provide ongoing monitoring, and continuously optimize for peak performance."
  }
];

export const companyInfo = {
  name: "Devsurf",
  tagline: "Intelligence driven growth, human-first results",
  mission: "To democratize artificial intelligence by creating innovative, accessible, and impactful AI solutions that transform businesses and improve lives.",
  vision: "A world where intelligent automation empowers every organization to achieve unprecedented efficiency and innovation.",
  values: [
    {
      title: "Innovation Excellence",
      description: "We push the boundaries of what's possible with AI technology."
    },
    {
      title: "Client Success",
      description: "Your success is our success. We're committed to delivering measurable results."
    },
    {
      title: "Ethical AI",
      description: "We develop responsible AI solutions that prioritize fairness, transparency, and privacy."
    },
    {
      title: "Continuous Learning",
      description: "We stay at the forefront of AI advancements to provide cutting-edge solutions."
    }
  ],
  contact: {
    email: "hello@devsurf.co",
    address: "Ahmedabad, India"
  },
  social: {
    linkedin: "https://www.linkedin.com/company/devsurf-co/",
    twitter: "https://twitter.com/devsurfco",
    instagram: "https://www.instagram.com/devsurf.co/"
  }
};